import { trackStructuredEvent } from 'analytics';

export function trackModuleView(url: string) {
  trackStructuredEvent({
    action: 'card-viewed',
    category: 'katalys-card',
    label: url,
  });
}
